"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var router_1 = require("@reach/router");
var core_1 = require("@theme-ui/core");
var react_1 = require("react");
var helpers_1 = require("../../helpers");
var ButtonLink_1 = __importDefault(require("../ButtonLink"));
var Links = function (_a) {
    var links = _a.links;
    var location = (0, router_1.useLocation)();
    return ((0, core_1.jsx)(react_1.Fragment, null, links === null || links === void 0 ? void 0 : links.map(function (link, index) {
        return (link === null || link === void 0 ? void 0 : link.label) && link.href !== null && link.href !== undefined ? ((0, core_1.jsx)("div", { key: link.href, sx: {
                marginLeft: index > 0 ? (0, helpers_1.responsive)({ lg: 4 }) : undefined,
                marginTop: (0, helpers_1.responsive)({ xs: 3, lg: 0 }),
                display: (0, helpers_1.responsive)({ lg: "inline-block" }),
                "&:first-of-type": {
                    marginTop: 0,
                },
            } },
            (0, core_1.jsx)(ButtonLink_1.default, { href: link.href, onClick: function (event) {
                    (0, helpers_1.scrollToAnchor)(event, location, link.href || null);
                } }, link.label))) : null;
    })));
};
exports.default = (0, react_1.memo)(Links);
